import request from "../utils/request";

// 登录
export function login(params) {
  return request({
    url: `/platform/userLogin`,
    method: "post",
    data:params
  });
}

// 注册
export function register(params) {
  return request({
    url: `/platform/userRegister`,
    method: "post",
    data:params
  });
}

// 获取用户列表
export function getUserMenu(params) {
  const queryString = Object.keys(params)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
  return request({
    url: `/platform/getUserMenu?${queryString}`,
    method: "get",
  });
}

// 修改用户菜单权限接口
export function updateUserMenu(params) {
  return request({
    url: `/platform/updateUserMenu`,
    method: "post",
    data:params
  });
}

// 修改密码
export function updatePassword(params) {
  return request({
    url: `/platform/updatePassword`,
    method: "post",
    data:params
  });
}